function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.77 16.23c1.186 0 2.202-.414 3.048-1.242.845-.828 1.267-1.824 1.267-2.988V5.23c0-1.163-.422-2.159-1.268-2.987C13.973 1.415 12.958 1 11.77 1c-1.187 0-2.203.415-3.048 1.243-.845.828-1.268 1.824-1.268 2.988V12c0 1.163.423 2.16 1.268 2.988.845.828 1.861 1.242 3.048 1.242z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.282 9.713a.837.837 0 00-.607-.252.839.839 0 00-.607.252.806.806 0 00-.256.595V12c0 1.63-.591 3.025-1.774 4.184-1.182 1.16-2.605 1.739-4.269 1.739-1.663 0-3.086-.58-4.269-1.739C6.318 15.026 5.727 13.631 5.727 12v-1.692a.805.805 0 00-.257-.595.838.838 0 00-.607-.252.838.838 0 00-.607.252.805.805 0 00-.256.595V12c0 1.948.663 3.643 1.99 5.083 1.326 1.441 2.965 2.268 4.916 2.48v1.744H7.453a.838.838 0 00-.607.252.805.805 0 00-.256.595c0 .229.085.427.256.595.17.167.373.251.607.251h8.632a.838.838 0 00.607-.251.805.805 0 00.257-.595.805.805 0 00-.257-.595.837.837 0 00-.607-.252h-3.452v-1.745c1.95-.211 3.59-1.038 4.916-2.479 1.326-1.44 1.99-3.135 1.99-5.083v-1.692a.805.805 0 00-.257-.595z",
  fill: "#000"
});

function SvgMicrophone(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgMicrophone;